import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

const getAuthHeaders = () => {
  const token = localStorage.getItem("eez7_client_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Verify payment status for a reservation
 * @param {number} reservationId - The reservation ID to verify
 * @returns {Promise<{reservationId: number, paymentStatus: string, status: string}>}
 */
export const verifyPayment = async (reservationId) => {
  const response = await axios.get(
    `${BASE_API}/payments/paymob/verify/${reservationId}`
  );
  return response.data;
};

/**
 * Initiate payment for an existing reservation (retry flow)
 * @param {number} reservationId - The reservation ID
 * @returns {Promise<{paymentUrl: string, paymobOrderId: number}>}
 */
export const initiatePayment = async (reservationId) => {
  const response = await axios.post(
    `${BASE_API}/payments/paymob/initiate/${reservationId}`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};

/**
 * Get reservation details with payment info
 * @param {number} reservationId - The reservation ID
 * @returns {Promise<Object>} - Reservation with payment details
 */
export const getReservationWithPayment = async (reservationId) => {
  const response = await axios.get(
    `${BASE_API}/reservations/${reservationId}`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};
